/**
 * Checks network status by probing an external endpoint.
 * @returns {Promise<{ online: boolean, reason: string }>} Network status.
 */
async function checkNetworkStatus() {
  const EXTERNAL_PROBE = 'https://www.gstatic.com/generate_204';
  const TIMEOUT_MS = 3000;

  async function fetchWithTimeout(input, init = {}) {
    const { timeoutMs = TIMEOUT_MS, ...rest } = init;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    try {
      return await fetch(input, { cache: 'no-store', signal: controller.signal, ...rest });
    } finally {
      clearTimeout(timeoutId);
    }
  }

  try {
    await fetchWithTimeout(EXTERNAL_PROBE, { mode: 'no-cors', timeoutMs: TIMEOUT_MS });
    return { online: true, reason: 'Internet available' };
  } catch (e) {
    return { online: false, reason: 'No internet connection' };
  }
}

export default checkNetworkStatus;
